import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

import { Carousel } from "@fancyapps/ui/dist/carousel/";
import "@fancyapps/ui/dist/carousel/carousel.css";

import { Dots } from "@fancyapps/ui/dist/carousel/carousel.dots.js";
import "@fancyapps/ui/dist/carousel/carousel.dots.css";

import { Arrows } from "@fancyapps/ui/dist/carousel/carousel.arrows.js";
import "@fancyapps/ui/dist/carousel/carousel.arrows.css";

import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.js";
import "@fancyapps/ui/dist/carousel/carousel.autoplay.css";

import { Sync } from "@fancyapps/ui/dist/carousel/carousel.sync.js";

function basicSlider(){
	const sliders = document.querySelectorAll('[data-name="basic-slider"]');

	if ( sliders.length === 0 ) return;
	
	sliders.forEach(slider => {
		const options = {
			Autoplay: {
				autoStart: true,
				timeout: 5000,
				pauseOnHover: true,
				showProgressbar: false
			},
			infinite: true,
		}

		Carousel(slider, options, { Autoplay }).init();
	});
}

function syncQuotesSliders() {
	const syncSliders = document.querySelectorAll('[data-name="sync-quote-slider"]');

	if (syncSliders.length === 0) return;

	syncSliders.forEach(slider => {
		const pictureSlider = slider.querySelector('[data-name="sync-quote-slider--picture"]');
		const contentSlider = slider.querySelector('[data-name="sync-quote-slider--content"]');

		if (!pictureSlider || !contentSlider) return;
		
		const contentOptions = {
			Autoplay: {
				autoStart: false,
				timeout: 5000,
				showProgressbar: false
			},
			transition: 'fade',
			infinite: true,
		};
		const contentInstance = Carousel(contentSlider, contentOptions, { Autoplay, Dots }).init();

		const pictureOptions = {
			Autoplay: {
				autoStart: false,
				timeout: 5000,
				showProgressbar: false
			},
			Sync: { target: contentInstance },
			transition: 'slide',
			infinite: true,
		};
		const pictureInstance = Carousel(pictureSlider, pictureOptions, { Autoplay, Sync }).init();

	});
}

function imageGallerySlider() {
	const sliders = document.querySelectorAll('[data-name="image-gallery-slider"]');
	
	if ( sliders.length === 0 ) return;

	sliders.forEach(slider => {
		const options = {
			Autoplay: {
				autoStart: false,
				timeout: 5000,
				pauseOnHover: true,
				showProgressbar: false
			},
			infinite: true,
			dragFree: true,
			Arrows: {
				prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" fill="none"><rect width="62" height="62" fill="#0F4DBC" rx="31" style="mix-blend-mode:difference"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M28.143 24.391 21 31.481m0 0 7.143 7.09M21 31.48h20"/></svg><svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g transform="translate(22,0) scale(-1,1)"><path d="M13.8571 1L21 8M21 8L13.8571 15M21 8L1 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg>',
				nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" fill="none"><rect width="62" height="62" fill="#0F4DBC" rx="31" style="mix-blend-mode:difference"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M33.857 24.391 41 31.481m0 0-7.143 7.09M41 31.48H21"/></svg><svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8571 1L21 8M21 8L13.8571 15M21 8L1 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
			}
		}

		Carousel(slider, options, { Autoplay, Arrows }).init();

		// Arrows without the mix-blend-mode:difference
		const prevButton = slider.querySelector( '[data-carousel-go-prev]' );
		if ( prevButton ) {
			const nextButtonCloned = prevButton.cloneNode( true );
			nextButtonCloned.classList.add('cloned');
			slider.appendChild( nextButtonCloned );
		}
		const nextButton = slider.querySelector( '[data-carousel-go-next]' );
		if ( nextButton ) {
			const nextButtonCloned = nextButton.cloneNode( true );
			nextButtonCloned.classList.add('cloned');
			slider.appendChild( nextButtonCloned );
		}

		// Check if any of the slides have a caption and move the buttons up.
		const hasCaption = slider.querySelector( '.f-carousel__slide figcaption' );
		if ( hasCaption ) {
			const captions = slider.querySelectorAll( '.f-carousel__slide figcaption' );
			let tallestCaption = captions[0];
			captions.forEach( caption => {
				if ( caption.offsetHeight > tallestCaption.offsetHeight ) {
					tallestCaption = caption;
				}
			});
			const tallestCaptionHeight = tallestCaption.offsetHeight;
			const buttons = slider.querySelectorAll( '.f-button.is-arrow' );
			
			// move the buttons up
			buttons.forEach(button => {
				const style = window.getComputedStyle(button);
				const insetValue = style.getPropertyValue('inset').trim();

				const tokens = insetValue.split(/\s+/);
				tokens[0] = `calc(${tokens[0]} - ${tallestCaptionHeight}px)`;
				button.style.inset = tokens.join(' ');
			});

		}
	});
}

function singleImageGallerySlider(){
	const sliders = document.querySelectorAll('[data-name="single-image-gallery-slider"]');
	
	if ( sliders.length === 0 ) return;

	sliders.forEach(slider => {
		const options = {
			Autoplay: {
				autoStart: false,
				timeout: 5000,
				pauseOnHover: true,
				showProgressbar: false
			},
			infinite: true,
			dragFree: true,
			Arrows: {
				prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none"><rect width="62" height="62" fill="#EBB700" rx="31" style="mix-blend-mode:difference"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M28.143 24.391 21 31.481m0 0 7.143 7.09M21 31.48h20"/></svg>',
				nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none"><rect width="62" height="62" fill="#EBB700" rx="31" style="mix-blend-mode:difference"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M33.857 24.391 41 31.481m0 0-7.143 7.09M41 31.48H21"/></svg>',
			}
		}

		Carousel(slider, options, { Autoplay, Arrows }).init();
	});
}

function overflowSlider(){
	const sliders = document.querySelectorAll('[data-name="overflow-slider"]');

	if ( sliders.length === 0 ) return;

	sliders.forEach(slider => {
		const options = {
			center: false,
			initialPage: 0,
			initialSlide: 0,
			Autoplay: {
				autoStart: false,
				timeout: 5000,
				pauseOnHover: true,
				showProgressbar: false
			},
			infinite: false,
			dragFree: true,
			fill: true,
		}

		const carouselInstance = Carousel(slider, options, { Autoplay }).init();

		// Wire custom navigation - buttons are outside the carousel element (in parent)
		const prevBtn = slider.parentElement.querySelector('[data-carousel-go-prev]');
		const nextBtn = slider.parentElement.querySelector('[data-carousel-go-next]');

		prevBtn?.addEventListener('click', () => carouselInstance.prev());
		nextBtn?.addEventListener('click', () => carouselInstance.next());
	});



	// Our Mission in Action slider: slide to the left staggered.
	const ourMissionInActionSliders = document.querySelectorAll('.our-mission-in-action-slider, .carousel-and-popups');
	if ( ourMissionInActionSliders.length ) {
		ourMissionInActionSliders.forEach(slider => {
			const buttonsContainer = slider.parentElement.querySelector('[data-name="overflow-slider--arrows"]');
			const articles = slider.querySelectorAll('.f-carousel__slide article');
			
			gsap.set( articles, { x: '110vw' } );
			gsap.set( buttonsContainer, { x: '110vw' } );
			
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: slider,
					start: 'top bottom-=100px',
				}
			});

			if ( buttonsContainer ) {
				tl.to( buttonsContainer, { 
					x: '0', 
					duration: 1, 
					ease: 'power2.out', 
					clearProps: 'all' 
				}, 0.2 );
			}
	
			tl.to( articles, { 
				x: '0', 
				duration: 1, 
				stagger: 0.2, 
				ease: 'power2.out', 
				clearProps: 'all' 
			}, 0.2 );
		});
	}
}

function featuredNewsSlider(){
	const sliders = document.querySelectorAll('[data-name="featured-news-slider"]');

	if ( sliders.length === 0 ) return;

	sliders.forEach(featuredNewsSlider => {
		const options = {
			center: false,
			initialPage: 0,
			initialSlide: 0,
			Autoplay: {
				autoStart: false,
				timeout: 5000,
				pauseOnHover: true,
				showProgressbar: false
			},
			infinite: true,
			transition: 'crossfade', // Options: 'slide', 'fade', 'crossfade', 'classic', false
		}

		const carouselInstance = Carousel(featuredNewsSlider, options, { Autoplay });
		carouselInstance.init();
		featuredNewsSlider.carouselInstance = carouselInstance;

		// Wire custom navigation - buttons are outside the carousel element (in parent)
		const arrowsWrap = featuredNewsSlider.parentElement?.querySelector('[data-name="featured-news-slider--arrows"]');
		const prevBtn = arrowsWrap?.querySelector('[data-carousel-go-prev]');
		const nextBtn = arrowsWrap?.querySelector('[data-carousel-go-next]');

		prevBtn?.addEventListener('click', () => carouselInstance.prev());
		nextBtn?.addEventListener('click', () => carouselInstance.next());
	});
}

function processSlider(){
	const sliders = document.querySelectorAll('[data-name="process-slider"]');

	if ( sliders.length === 0 ) return;

	sliders.forEach(slider => {
		const options = {
			center: false,
			initialPage: 0,
			initialSlide: 0,
			Autoplay: {
				autoStart: false,
				timeout: 5000,
				pauseOnHover: true,
				showProgressbar: false
			},
			Arrows: {
				prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" fill="none"><rect width="62" height="62" fill="#0F4DBC" rx="31" style="mix-blend-mode:difference"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M28.143 24.391 21 31.481m0 0 7.143 7.09M21 31.48h20"/></svg><svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g transform="translate(22,0) scale(-1,1)"><path d="M13.8571 1L21 8M21 8L13.8571 15M21 8L1 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg>',
				nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" fill="none"><rect width="62" height="62" fill="#0F4DBC" rx="31" style="mix-blend-mode:difference"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M33.857 24.391 41 31.481m0 0-7.143 7.09M41 31.48H21"/></svg><svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8571 1L21 8M21 8L13.8571 15M21 8L1 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
			}
		}

		const carouselInstance = Carousel(slider, options, { Autoplay, Arrows })
		carouselInstance.init();
		slider.carouselInstance = carouselInstance;

		// Arrows without the mix-blend-mode:difference
		const prevButton = slider.querySelector( '[data-carousel-go-prev]' );
		if ( prevButton ) {
			const nextButtonCloned = prevButton.cloneNode( true );
			nextButtonCloned.classList.add('cloned');
			slider.appendChild( nextButtonCloned );
		}
		const nextButton = slider.querySelector( '[data-carousel-go-next]' );
		if ( nextButton ) {
			const nextButtonCloned = nextButton.cloneNode( true );
			nextButtonCloned.classList.add('cloned');
			slider.appendChild( nextButtonCloned );
		}

		// Get the header and create the blue progress line
		const header = slider.parentElement.querySelector('header');
		const dots = slider.parentElement.querySelectorAll('[data-name="process-step-dot"]');
		const dotSvgs = slider.parentElement.querySelectorAll('[data-name="process-step-dot-svg"]');

		if (header && dots.length > 0) {
			// Create the blue progress line
			const progressLine = document.createElement('div');
			progressLine.setAttribute('data-name', 'process-step-progress-line');
			progressLine.className = 'h-4 bg-blue absolute bottom-12 left-0 ease-in-out';
			progressLine.style.width = '0%';
			progressLine.style.transition = 'width 500ms ease-in-out';
			header.appendChild(progressLine);

			// Function to check if progress line has reached a dot
			const checkProgressLinePosition = () => {
				const headerRect = header.getBoundingClientRect();
				// Get the actual rendered width of the progress line
				const progressLineRect = progressLine.getBoundingClientRect();
				const progressLineWidth = progressLineRect.width;

				dots.forEach((dot, index) => {
					const dotSvg = dotSvgs[index];
					const dotRect = dot.getBoundingClientRect();
					const dotCenter = dotRect.left + (dotRect.width / 2) - headerRect.left;

					// Check if the progress line has reached this dot's center (with small threshold)
					if (progressLineWidth >= (dotCenter - 1)) {
						// Dot is reached
						if (!dot.classList.contains('bg-blue')) {
							dot.classList.remove('bg-grey');
							dot.classList.add('bg-blue');
						}
						if (dotSvg && dotSvg.style.opacity !== '1') {
							dotSvg.style.opacity = '1';
						}
					} else {
						// Dot is not reached yet
						if (!dot.classList.contains('bg-grey')) {
							dot.classList.remove('bg-blue');
							dot.classList.add('bg-grey');
						}
						if (dotSvg && dotSvg.style.opacity !== '0') {
							dotSvg.style.opacity = '0';
						}
					}
				});
			};

			// Store animation frame ID at a higher scope
			let currentAnimationFrameId = null;

			// Function to update the progress line and dots
			const updateProgressLine = (activeIndex) => {
				if (dots.length === 0) return;

				// Get the position of the active dot
				const activeDot = dots[activeIndex];
				if (!activeDot) return;

				// Calculate the width: from start to the center of the active dot
				const headerRect = header.getBoundingClientRect();
				const dotRect = activeDot.getBoundingClientRect();
				const dotCenter = dotRect.left + (dotRect.width / 2) - headerRect.left;

				// Cancel any previous animation
				if (currentAnimationFrameId) {
					cancelAnimationFrame(currentAnimationFrameId);
					currentAnimationFrameId = null;
				}

				// Set the width of the progress line
				progressLine.style.width = `${dotCenter}px`;

				// Update state classes (active/passed) immediately
				dots.forEach((dot, index) => {
					const dotSvg = dotSvgs[index];

					// Remove all state classes first
					dot.classList.remove('active', 'passed');
					if (dotSvg) {
						dotSvg.classList.remove('active', 'passed');
					}

					if (index === activeIndex) {
						// Current active dot
						dot.classList.add('active');
						if (dotSvg) {
							dotSvg.classList.add('active');
						}
					} else if (index < activeIndex) {
						// Passed dots
						dot.classList.add('passed');
						if (dotSvg) {
							dotSvg.classList.add('passed');
						}
					}
				});

				// Listen for transition end as a backup
				const handleTransitionEnd = () => {
					checkProgressLinePosition();
					progressLine.removeEventListener('transitionend', handleTransitionEnd);
				};
				progressLine.addEventListener('transitionend', handleTransitionEnd);

				// Monitor the progress line animation
				const startTime = performance.now();
				const duration = 600; // Slightly longer than transition to ensure we catch everything

				const animate = (currentTime) => {
					const elapsed = currentTime - startTime;

					checkProgressLinePosition();

					if (elapsed < duration) {
						currentAnimationFrameId = requestAnimationFrame(animate);
					} else {
						// Multiple final checks to ensure everything is set
						checkProgressLinePosition();
						setTimeout(() => {
							checkProgressLinePosition();
						}, 50);
						currentAnimationFrameId = null;
					}
				};

				// Start checking immediately
				checkProgressLinePosition();
				currentAnimationFrameId = requestAnimationFrame(animate);
			};

			// Update on carousel change
			carouselInstance.on('change', (instance) => {
				const pageIndex = instance.getPageIndex();
				updateProgressLine(pageIndex);
			});

			// Initial update
			updateProgressLine(0);
		}

		// Add click event to the tabs (timeline style).
		const tabs = slider.parentElement.querySelectorAll('[data-name="process-step-stop"]');
		if ( tabs.length > 0 ) {
			tabs.forEach((tab, index) => {
				tab.addEventListener('click', () => {
					const slider = tab.closest('[data-block="process"]')?.querySelector('[data-name="process-slider"]');

					if ( slider ) {
						if (slider && slider.carouselInstance) {
							slider.carouselInstance.goTo(index);
						}
					}
				});
			});
		}


	});
}


function syncNews(){
	const syncSliders = document.querySelectorAll('[data-name="sync-news-slider"]');

	if (syncSliders.length === 0) return;

	syncSliders.forEach(slider => {
		const pictureSlider = slider.querySelector('[data-name="sync-news-slider--picture"]');
		const contentSlider = slider.querySelector('[data-name="sync-news-slider--content"]');

		if (!pictureSlider || !contentSlider) return;

		// ── Content slider: fade transition (unchanged) ──────────────────────────
		const contentOptions = {
			Autoplay: {
				autoStart: false,
				timeout: 5000,
				showProgressbar: false,
			},
			transition: 'fade',
			infinite: true,
		};
		const contentInstance = Carousel(contentSlider, contentOptions, { Autoplay, Dots }).init();

		// ── Picture slider: custom clip-path wipe, no built-in transition ────────
		const pictureOptions = {
			Autoplay: {
				autoStart: false,
				timeout: 5000,
				showProgressbar: false,
			},
			Sync: {
				target: contentInstance,
				syncOnChange: true,
			},
			// Disable FancyApps slide/fade so we can drive the animation ourselves
			transition: false,
			infinite: true,
			// Bypasses FancyApps' internal slider logic so it doesn't try to apply translate3d
			// leaving full visual control to our CSS and GSAP.
			setTransform: () => {},
		};
		const pictureInstance = Carousel(pictureSlider, pictureOptions, { Autoplay, Sync }).init();

		// Duration of the wipe (seconds)
		const WIPE_DURATION = 0.75;
		const WIPE_EASE     = 'power2.inOut';

		// Track whether a wipe is running so we never double-fire
		let isAnimating = false;

		/**
		 * Return all .f-carousel__slide elements inside the picture viewport.
		 */
		const getSlides = () =>
			Array.from(pictureSlider.querySelectorAll('.f-carousel__slide'));

		/**
		 * Stack all slides absolutely so they sit on top of each other.
		 * FancyApps normally handles layout; since we disabled transition we
		 * take over positioning here.
		 */
		const stackSlides = () => {
			const viewport = pictureSlider.querySelector('.f-carousel__viewport');
			if (viewport) {
				viewport.style.position = 'relative';
				viewport.style.overflow = 'hidden';
				viewport.style.height   = '100%';
			}
			getSlides().forEach(slide => {
				slide.style.position  = 'absolute';
				slide.style.inset     = '0';
				slide.style.width     = '100%';
				slide.style.height    = '100%';
				slide.style.transform = 'none';
				slide.style.clipPath  = 'none';
			});
		};

		/**
		 * Show only the slide at `index`, hiding all others.
		 * Called on init and after each wipe completes.
		 */
		const showSlide = (index) => {
			const slides = getSlides();
			slides.forEach((slide, i) => {
				slide.style.zIndex    = i === index ? '2' : '0';
				slide.style.clipPath  = 'none';
				slide.style.opacity   = i === index ? '1' : '0';
				slide.style.transform = 'none';
			});
		};

		/**
		 * Animate a clip-path wipe from the current slide to the next.
		 *
		 * Going FORWARD (next): the outgoing slide wipes from RIGHT to LEFT
		 *   inset(0 0% 0 0)  →  inset(0 100% 0 0)
		 *
		 * Going BACKWARD (prev): the outgoing slide wipes from LEFT to RIGHT
		 *   inset(0 0 0 0%)  →  inset(0 0 0 100%)
		 */
		const wipeToSlide = (fromIndex, toIndex, direction) => {
			if (isAnimating) return;
			isAnimating = true;

			const slides = getSlides();
			const outgoing = slides[fromIndex];
			const incoming = slides[toIndex];

			if (!outgoing || !incoming) {
				isAnimating = false;
				return;
			}

			// Hide all other slides to prevent z-index stacking bugs
			slides.forEach((slide, i) => {
				if (i !== fromIndex && i !== toIndex) {
					slide.style.zIndex  = '0';
					slide.style.opacity = '0';
				}
			});

			// Place incoming behind outgoing, both visible
			incoming.style.zIndex    = '1';
			incoming.style.clipPath  = 'none';
			incoming.style.opacity   = '1';
			incoming.style.transform = 'none';

			outgoing.style.zIndex    = '2';
			outgoing.style.opacity   = '1';
			outgoing.style.transform = 'none';

			// Start clip-path state of outgoing: fully visible
			const clipStart = direction === 'forward'
				? 'inset(0 0% 0 0)'
				: 'inset(0 0 0 0%)';

			// End clip-path state: fully hidden
			const clipEnd = direction === 'forward'
				? 'inset(0 100% 0 0)'
				: 'inset(0 0 0 100%)';

			gsap.fromTo(
				outgoing,
				{ clipPath: clipStart },
				{
					clipPath: clipEnd,
					duration: WIPE_DURATION,
					ease: WIPE_EASE,
					onComplete: () => {
						showSlide(toIndex);
						isAnimating = false;
					},
				}
			);
		};

		// ── Bootstrap ────────────────────────────────────────────────────────────

		// Wait one tick so FancyApps has finished its initial render
		requestAnimationFrame(() => {
			stackSlides();
			showSlide(0);
		});

		// 'change' fires after FancyApps has committed to the new page.
		// Signature: (instance, currentPageIndex, prevPageIndex)
		pictureInstance.on('change', (instance, currentPage, prevPage) => {
			if (prevPage === undefined || prevPage === currentPage) return;

			const from  = prevPage;
			const to    = currentPage;
			const total = getSlides().length;

			const forwardDist  = (to - from + total) % total;
			const backwardDist = (from - to + total) % total;
			const direction    = forwardDist <= backwardDist ? 'forward' : 'backward';

			wipeToSlide(from, to, direction);

			// Also smoothly slide the content text to match the direction
			const conSlides   = Array.from(contentSlider.querySelectorAll('.f-carousel__slide'));
			const conOutgoing = conSlides[from]?.querySelector('article');
			const conIncoming = conSlides[to]?.querySelector('article');
			
			const slideAmount = 30;

			if (conOutgoing) {
				gsap.fromTo(conOutgoing, 
					{ x: 0 }, 
					{ x: direction === 'forward' ? -slideAmount : slideAmount, duration: WIPE_DURATION, ease: WIPE_EASE, clearProps: 'x' }
				);
			}
			if (conIncoming) {
				gsap.fromTo(conIncoming, 
					{ x: direction === 'forward' ? slideAmount : -slideAmount }, 
					{ x: 0, duration: WIPE_DURATION, ease: WIPE_EASE, clearProps: 'x' }
				);
			}
		});
	});
}

function sliders(){
	basicSlider()
	syncQuotesSliders()
	imageGallerySlider()
	singleImageGallerySlider()
	overflowSlider()
	featuredNewsSlider()
	processSlider()
	syncNews()
}

export { sliders };